<template lang="html">
  <div class='dashboard-alert'>
    <transition name="fade">
      <div v-if="message" :class="[klass]">
         {{message}}
       </div>
     </transition>
  </div>
</template>

<script>
export default {
  props: ['message', 'klass'],
  methods: {
    hideAlert() {
      this.$emit('update:message', '');
    }
  },
  watch: {
    message(newValue) {
      if (newValue) {
        setTimeout(this.hideAlert, 2000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-alert {
  flex-grow: 1;
  text-align: left;

  div {
    color: #d00000;
    text-align: center;
  }
}
</style>
